/**
 * Feature flags for controlling application behavior
 */
export const featureFlags = {
  newAgentPage: true,
  enablePolling: true,
  enableWorkflows: false, // Workflow menu visible only to admins when enabled
} as const;

export type FeatureFlagKey = keyof typeof featureFlags;